import {
  VentaPendienteMaster,
  formatComprobanteVentaMasterDisplay,
} from '../../../services/ventasSeguimientoService';
import { POSLineaPendienteMeta } from './types';

export function pendienteMetaDesdeMaster(p: VentaPendienteMaster): POSLineaPendienteMeta {
  return {
    comprobanteDisplay: formatComprobanteVentaMasterDisplay(p),
    fechaEmision: p.fechaEmisionComprobanteMaster ?? null,
    cantidadPedida: p.cantidadPedida,
    cantidadFacturada: p.cantidadFacturada,
    cantidadRemitida: p.cantidadRemitida,
    pendienteFacturar: p.pendienteFacturar,
    pendienteEntregar: p.pendienteEntregar,
  };
}

export function lineaTieneOrigenMaster(linea: {
  nroFormularioMaster?: number;
  nroItemMaster?: number;
}): boolean {
  const nfm = Number(linea.nroFormularioMaster);
  const nim = Number(linea.nroItemMaster);
  return Number.isFinite(nfm) && nfm > 0 && Number.isFinite(nim) && nim > 0;
}

export function formatFechaEmisionMaster(value?: string | null): string {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString('es-AR');
}
